<div class="card">
  <h5 class="card-header">Enable Master Account</h5>
  <div class="card-body">
    <div class="progress_bar">
      <div class="progress" [ngStyle]="{'width': ((step / steps) * 100) + '%'}"></div>
    </div>
    <div *ngIf="step == 1">
      <form (submit)="reviewAccount()">
        <div>
          <label class="label">Master Account ID</label>
          <input autocomplete="off" type="text" class="form-control" name="masteraccountid" [(ngModel)]="mai">
        </div>
        <div>
          <label class="label">Account Name</label>
          <input autocomplete="off" type="text" class="form-control" name="masteraccountname" [(ngModel)]="an">
        </div>
        <div>
          <label class="label">Bucket Name</label>
          <input autocomplete="off" type="text" class="form-control" name="bucketname" [(ngModel)]="bn">
        </div>
        <div>
          <label class="label">Folder Name</label>
          <input autocomplete="off" type="text" class="form-control" name="foldername" [(ngModel)]="folderName">
        </div>
        <div>
          <label class="label">Region</label>
          <select class="form-control" id="regionsList" name="regions" [(ngModel)]="region" data-live-search="true">
            <option *ngFor="let region of regions" value="{{region.id}}">{{region.name}}</option>
          </select>
        </div>
        <div class="review_31">
          <button class="btn btn-light review_31" type="submit">Review</button>
        </div>
      </form>
    </div>
    <div *ngIf="step == 2">
      <form (submit)="sendOTP()">
        <div class="step_opt_38">
          <div>Master Account ID</div>
          <div class="account_id_40">{{mai}}</div>
        </div>
        <div class="step_opt_38">
          <div>Account Name</div>
          <div class="account_id_40">{{an}}</div>
        </div>
        <div class="step_opt_38">
          <div>Bucket Name</div>
          <div class="account_id_40">{{bn}}</div>
        </div>
        <div class="step_opt_38">
          <div>Folder Name</div>
          <div class="account_id_40">{{folderName}}</div>
        </div>
        <div class="step_opt_38">
          <div>Region</div>
          <div class="account_id_40">{{region}}</div>
        </div>
        <div class="review_31">
          <button class="btn btn-light" type="button" (click)="step = 1">Back</button>
          <button class="btn btn-light review_31" type="submit">Submit</button>
        </div>
      </form>
    </div>
    <div *ngIf="step == 3">
      <form (submit)="validateOTP()" name="validateOTPForm">
        <div>
          <label class="label" name="otp">OTP</label>
          <input autocomplete="off" name="otp" type="text" class="form-control" [(ngModel)]="otp">
        </div>
        <div class="back_70">
          <button class="btn btn-light" type="button" (click)="step = 2">Back</button>
          <button class="btn btn-light" type="button" (click)="sendOTP()">Send Again</button>
          <button class="btn btn-light review_31" type="submit">Submit</button>
        </div>
      </form>
    </div>
  </div>
</div>